var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0",attrs:{"app":"","fluid":true}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-card',[_c('SalesChart')],1)],1),_c('v-col',{attrs:{"cols":"6"}},[_c('v-card',[_c('ProductsChart')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }